import { render, staticRenderFns } from "./BinanceQr.vue?vue&type=template&id=245bb9de&"
import script from "./BinanceQr.vue?vue&type=script&lang=js&"
export * from "./BinanceQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports